// Feb-2026 — ZB1/COC-Scan-Ergebnis auf den Formular-State anwenden, ausgelagert
// aus CreateListingPage.jsx. Übernimmt extrahierte Felder, normalisiert
// Title-Case, leitet PS/Titel ab, archiviert Dokumente und markiert KI-Quellen.
export function applyZb1Result(fields, { setForm, markAiFields }) {
    setForm((p) => {
        const next = { ...p };
        const KEYS = [
            "hsn", "tsn", "vin", "brand", "model", "manufacturer",
            "vehicle_class", "displacement", "power_kw", "power_rpm", "fuel",
            "max_speed_kmh", "emission_class", "seat_count",
            "length_mm", "width_mm", "height_mm", "weight_kg",
            "max_weight_kg", "first_registration_date",
            "license_plate", "bemerkungen",
            "previous_owner_first_name",
            "previous_owner_last_name_or_company",
            "previous_owner_street", "previous_owner_house_number",
            "previous_owner_postal_code", "previous_owner_city",
            "mileage", "last_service_date", "has_service_book", "service_notes",
            // Feb-2026 Iter 28 (User-Wunsch 25 May, Update v7) — Reifen
            // + TÜV + Abmeldung aus ZB1-Scan
            "tire_size_front", "tire_size_rear",
            "tuev_until", "deregistered", "deregistered_date",
        ];
        KEYS.forEach((k) => {
            if (fields[k] != null && fields[k] !== "") next[k] = fields[k];
        });
        // Feb-2026 Iter 28 (User-Wunsch 25 May, Update v11): Brand
        // Title-Case normalisieren (ZB1/KBA liefern oft "PIAGGIO" → "Piaggio"),
        // damit der Brand-Select-Eintrag matcht und die Marke korrekt
        // gerendert wird. Sonst greift die nachfolgende Modell-Präfix-Strip-
        // Logik nicht, weil Marke und Modell-Prefix Case-Mismatch haben.
        if (typeof next.brand === "string" && next.brand) {
            next.brand = next.brand.charAt(0).toUpperCase() + next.brand.slice(1).toLowerCase();
        }
        if (typeof next.manufacturer === "string" && next.manufacturer) {
            next.manufacturer = next.manufacturer.charAt(0).toUpperCase() + next.manufacturer.slice(1).toLowerCase();
        }
        // Modell ebenfalls Title-Case (z. B. „VESPA GTS" → „Vespa GTS")
        if (typeof next.model === "string" && next.model) {
            next.model = next.model
                .split(/\s+/)
                .map((w) => w.length <= 3 ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                .join(" ");
        }
        if (fields.seat_count != null && fields.seat_count !== "") {
            next.seat_count = String(fields.seat_count);
        }
        if (fields.model && fields.brand) {
            const m = String(fields.model).trim();
            const b = String(fields.brand).trim();
            if (m.toLowerCase().startsWith(b.toLowerCase() + " ")) {
                next.model = m.slice(b.length + 1).trim();
            }
        }
        if (fields.power_kw && !p.power_hp) {
            next.power_hp = String(Math.round(Number(fields.power_kw) * 1.35962));
        }
        if (!p.title && next.brand && next.model) {
            next.title = `${next.brand} ${next.model}`;
        }
        const docsToAdd = Array.isArray(fields.__zb1_documents) && fields.__zb1_documents.length
            ? fields.__zb1_documents
            : (fields.__zb1_document?.url ? [fields.__zb1_document] : []);
        if (docsToAdd.length) {
            const existing = Array.isArray(p.document_urls) ? p.document_urls : [];
            const existingUrls = new Set(existing.map((d) => typeof d === "string" ? d : d?.url));
            const merged = [...existing];
            docsToAdd.forEach((doc) => {
                if (!doc?.url || existingUrls.has(doc.url)) return;
                merged.push({
                    url: doc.url,
                    name: doc.name || "Dokument",
                    kind: doc.kind || "unknown",
                });
                existingUrls.add(doc.url);
                if (doc.kind === "coc") next.has_coc = true;
                else if (doc.kind === "zb2") next.has_zb2 = true;
                else if (doc.kind === "service_heft") next.has_service_book = true;
                else next.has_zb1 = true;
            });
            next.document_urls = merged;
        }
        return next;
    });
    // KI-Quelle markieren: alle aus dem Scan tatsächlich gelieferten Felder
    // + abgeleitete (power_hp, title).
    const ZB1_AI_KEYS = [
        "hsn", "tsn", "vin", "brand", "model", "manufacturer",
        "vehicle_class", "displacement", "power_kw", "power_rpm", "fuel",
        "max_speed_kmh", "emission_class", "seat_count",
        "length_mm", "width_mm", "height_mm", "weight_kg",
        "max_weight_kg", "first_registration_date",
        "license_plate", "bemerkungen",
        "mileage", "last_service_date", "service_notes",
        "tire_size_front", "tire_size_rear", "tuev_until",
    ];
    const aiKeys = ZB1_AI_KEYS.filter((k) => fields[k] != null && fields[k] !== "");
    if (fields.power_kw) aiKeys.push("power_hp");
    if (fields.brand && fields.model) aiKeys.push("title");
    markAiFields(aiKeys);
}
